import { render, staticRenderFns } from "./TenantDetailForm.vue?vue&type=template&id=18b7feee&"
import script from "./TenantDetailForm.vue?vue&type=script&lang=js&"
export * from "./TenantDetailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports